import CryptoJS from "crypto-js";
import { JSEncrypt } from "jsencrypt";
import { method } from "lodash";
import { useEffect, useState } from "react";

const AESkey = process.env.REACT_APP_AES_KEY || ""
const AESiv = process.env.REACT_APP_AES_IV || ""

const publicKey =
  "-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAskgPKBcNpz71mi4NSYa5mazJrO0WZim7T2yy7qPxk2NqQE7OmWWakLJcaeUYnI0kO3yC57vck66RPCjKxWuWSGZ7dHXe0bWb5IXjcT4mNdnUIalR+lV8czsoH/wDUvkQdG1SJ+IxzW64WvoaCRZ+/4wBF2cSUh9oLwGEXiodUJ9oJXFZVPKGCEjPcBI0vC2ADBRmVQ1sKsZg8zbHN+guU9rPLFzN4YNrCnEsSezVw/W1FKVS8J/Xx4HSSg7AyVwniz8eHi0e3a8VzFg+H09I5wK+w39sjDYfAdnJUkr6PjtSbN4/Sg/NMkKB2Ngn8oj7LCfe/7RNqIdiS+dQuSFgeQIDAQAB -----END PUBLIC KEY-----";
const privateKey =
  "-----BEGIN RSA PRIVATE KEY-----MIIEpAIBAAKCAQEAskgPKBcNpz71mi4NSYa5mazJrO0WZim7T2yy7qPxk2NqQE7OmWWakLJcaeUYnI0kO3yC57vck66RPCjKxWuWSGZ7dHXe0bWb5IXjcT4mNdnUIalR+lV8czsoH/wDUvkQdG1SJ+IxzW64WvoaCRZ+/4wBF2cSUh9oLwGEXiodUJ9oJXFZVPKGCEjPcBI0vC2ADBRmVQ1sKsZg8zbHN+guU9rPLFzN4YNrCnEsSezVw/W1FKVS8J/Xx4HSSg7AyVwniz8eHi0e3a8VzFg+H09I5wK+w39sjDYfAdnJUkr6PjtSbN4/Sg/NMkKB2Ngn8oj7LCfe/7RNqIdiS+dQuSFgeQIDAQABAoIBAQCtAyEyVqz5UTAnn+llIUmcyQIuvyatnnIYcfRzgsY9soy6O8BjPSbypSTp31ozEwXGdN7U5Ir7Br4LE8s0K2R8fnfwXTMPcJ8I9qXyj82lFO+4ewkDV1KewRn/cCIJs4s0caL48ZpDMt/V6kC58QruFIA6pdwxtij09RPwDg7E3U1MrL9PqgGXXQcAwtboP7gHs2ac+0b6CwV0Cyev09Xpni3ID0iKX8yKsxi6wOh+2O4Mz8B3R2gIXq7Gzw8oeho0nSBD19B7fWs+w4vFlHIl57zbeISQK10cvvJ8BB4byy/bn5V2O2lESgU10d48csD5IUcjdV4/yuFxvI8S9vfBAoGBAOqbw03WXnhZQu8O7Gos8P7lrBi3eYdF45hHAfWbK5ub6O7fC0kQFYZqO0AR7oEAzuApWP0uGxQFALZ0QPyFZbpnKinE9T9a4M5AaP1Ex8WmeWbto96bmd6jVRXKXz24x5GDk+UdF7PJF91DufpUB5ZaO/AXpB9/3R9BDu7JHTjzAoGBAMKJgrfZmyH3B9Cslnb8HUSlbXZQ/tnLoc3DpXnaENpYKWz/FMjqxTHuVRRqH86tYL33/ow3UCaN3EYgIguoVC+DTbzk3/I9IXXeDXrocH1qCUy+x6dohzPoKZMoILLs+VeFeAJfIptgVIfcD5teKdEY4lYPbV0m47Q2ET8pgNvjAoGADWgDPBJw6Y2oPoLqzZJt3xL+x5bMcgdzXwNHwGIylrzNDcFfIrixkjHF2v5rU6HZMIQMWsNktrsmdEamZAe3bXRxu1tO7GTkDcUuerKQe+HsdA5GW/UmUMuilBExahSCCvWq4N/Nt+9Y1sMFAKIGoPfdDvY64bXry9pq4QhLDDMCgYAGs9ovH24641n/lJKyksknXlPBKdU+B8gRYNZItnyyKSt0N+2tZnlY2Q9RXr6tzkdxBCRfDGDUkzqtp9nEcQ5FfM6m3XPh0r1eZEIuo+eMSqT7Ye9bEzzlSvBzw4Qs5gFJRK331vNISy9eZvSas8nZDHRv5qQr+3UI9nvtoy5vZQKBgQCK5z2IeL1NFd5OuJaR07Y+xwO7IOiZ+nn+fXWYkZ4bD08Dg0ACnd/wOcS+2fU2/IIuXnhT/f5M5r0AJI1lG/V8TBo4gxN2dm7yBLgczbK3u+tex+pEnfEZqxAE0159q3iGvU5nmtX6VC0Z/IJIUCVgiEMwoKct0T5eOV2iQf5PaQ== -----END RSA PRIVATE KEY-----";

export function ServiceProvider() {}
export async function uploadFile(url, formData) {
  const response = await fetch(url, {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    credentials: "same-origin",
    body: formData, // send FormData object
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  return response.json();
}

export async function GetPostMethodData(url = "", data = {}) {
  const response = await fetch(url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  });
  return response.json();
}

// Dedicated method for PDF upload
export async function UploadPDF(url, file, fileName) {
  // Create a new FormData instance
  const fileFormData = new FormData();

  // Append the PDF file and its name to the FormData object
  fileFormData.append("formFile", file);
  fileFormData.append("fileName", fileName);

  try {
    // Make the API call to upload the file
    const response = await fetch(url, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      // Do not set the Content-Type header manually for FormData
      redirect: "follow",
      referrerPolicy: "no-referrer",
      body: fileFormData,
    });

    // Check if the response is successful
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Return the JSON response
    return await response.json();
  } catch (error) {
    // Handle any errors that occur during the file upload
    console.error("Error uploading PDF:", error.message);
    throw error;
  }
}

export async function GetMethodData(url = "", data = {}) {
  const response = await fetch(url, {
    method: "GET", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
  });

  return response.json(); // parses JSON response into native JavaScript objects
}

export function DecryptAESdata(data) {
  var AESdata = CryptoJS.AES.decrypt(data, CryptoJS.enc.Utf8.parse(AESkey), {
    iv: CryptoJS.enc.Utf8.parse(AESiv), // parse the IV
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  });
 
  return JSON.parse(AESdata.toString(CryptoJS.enc.Latin1));
}

export function DecryptAESdataPanCard(data) {
  var AESdata = CryptoJS.AES.decrypt(data, CryptoJS.enc.Utf8.parse(AESkey), {
    iv: CryptoJS.enc.Utf8.parse(AESiv),
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  });

  // Just return the UTF8 string, do NOT parse as JSON
  return AESdata.toString(CryptoJS.enc.Utf8);
}

export function EncryptAES(data) {
  // Parse key and IV as Utf8
  const key = CryptoJS.enc.Utf8.parse(AESkey);
  const iv = CryptoJS.enc.Utf8.parse(AESiv);

  // Encrypt
  const encrypted = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  });

  // Return Base64 string (this is what .NET expects)
  return encrypted.toString();
}

export async function GetEncryptWithStatic(url = "", data = {}) {
  try {
    const response = await fetch(url, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      redirect: "follow",
      referrerPolicy: "no-referrer",
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(
        `Error occurred while fetching API: ${response.statusText}`
      );
    }

    const responseData = await response.json();

    if (responseData == null) {
      throw new Error("Empty response received from the server");
    }

    return responseData;
  } catch (error) {
    console.error("Error during API request:", error.message);
    return null;
  }
}
export async function GetDecryptWithStatic(url = "", data = {}) {
  try {
    const response = await fetch(url, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        // Add additional headers if needed for encryption or other purposes
      },
      redirect: "follow",
      referrerPolicy: "no-referrer",
      body: data, // Ensure that data is a valid JSON string or binary data
    });

    if (!response.ok) {
      throw new Error(
        `Error occurred while fetching API: ${response.statusText}`
      );
    }

    // Adjust this part based on how the server responds with encrypted data
    const responseData = await response.json();

    if (responseData == null) {
      throw new Error("Empty response received from the server");
    }

    // If needed, add code to decrypt responseData here

    return responseData;
  } catch (error) {
    console.error("Error during API request:", error.message);
    return null;
  }
}
